module.exports = __webpack_public_path__ + "static/react-notifs-8ce91c6b0e41bab69cb3e56673cbc632.gif";